import RestService from '../services/rest';

async function getManualRequestOptions() {
  return RestService.getAuthenticated('inboundManualRequest/list/options');
}

async function getManualRequestOptionsProducts(productFilter) {
  return RestService.getAuthenticated(
    'inboundManualRequest/list/options/products',
    {},
    {},
    { params: { productFilter } },
  );
}

async function createManualRequest(newManualRequest) {
  return RestService.postAuthenticated('inboundManualRequest/create', newManualRequest);
}

export default {
  createManualRequest,
  getManualRequestOptions,
  getManualRequestOptionsProducts,
};
